module.exports = __webpack_public_path__ + "img/7.a8da3666.jpg";